import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, Button , DialogTitle} from '@mui/material';

function CustomConfirmationDialog({ open, onClose, onConfirm }) {
    const dialogContentTextStyle = {
        fontSize: '18px', // Adjust the font size as needed
    };

    const buttonStyle = {
        color: 'black',
        backgroundColor: 'rgba(211, 211, 211, 0.3)',
        margin: '20px',
        fontSize: '13px',
    };

    const dialogContentStyle = {
        padding: '20px 24px 0px 24px', // Top, Right, Bottom, Left
    };

    const dialogActionsStyle = {
        padding: '4px 20px', // Reduce the padding here for less space
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogContent style={dialogContentStyle}>
                <DialogContentText id="alert-dialog-description" style={dialogContentTextStyle}>
                    You have not answered the question. Would you like to continue?
                </DialogContentText>
            </DialogContent>
            <DialogActions style={dialogActionsStyle}>
                <Button onClick={onClose} style={buttonStyle}>
                    Answer the question
                </Button>
                <Button onClick={onConfirm} style={buttonStyle} autoFocus>
                    Continue without answering
                </Button>
            </DialogActions>
        </Dialog>
    );
}

function CustomWordCountDialog({ open, onClose }) {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogContent>
                <DialogContentText>
                    Your response should be at least 100 words.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    );
}


function CustomRecordingDoneDialog({ open, onClose, title, description, buttonText }) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {description}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    {buttonText || 'Close'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}


function CustomHourDialog({ open, onClose }) {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogContent>
                <DialogContentText>
                    Your response choices should add up to 24 hours. 
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    );
}



export {CustomWordCountDialog, CustomConfirmationDialog, CustomRecordingDoneDialog, CustomHourDialog}

